
import React, { useEffect } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Link, useParams } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { ReactComponent as Status } from "../../Global Icons/Status.svg";
import { useDispatch, useSelector } from "react-redux";
import { viewCabRequest } from "../../Redux/Actions/cabRequestActions";
import { ToFirstCapital } from "../../Utils/helpers";
import moment from "moment";
import "./cab.css";

const ViewCabSettings = () => {
  const FLAG_URL = process.env.REACT_APP_API_FLAG_URL;
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(viewCabRequest(id));
  }, [id, dispatch]);

  const { cab } = useSelector((state) => state.cabs || {});
  const data = cab?.data;

  return (
    <MainLayout>
      <div className="cab-view-container">
        <div className="cab-header">
          <Link to="/cab_settings">
            <BackIcon className="back-icon" />
          </Link>
          <h1>{ToFirstCapital(data?.name) || "N/A"}</h1>
        </div>

        <div className="cab-card">
          <div className="cab-info-top">
            <img src={data?.image} alt="Cab" className="cab-image" />

            <div className="cab-info-item">
              <p className="cab-label">Cab Name</p>
              <p className="value">{ToFirstCapital(data?.name)}</p>
            </div>
            <div className="cab-info-item">
              <p className="cab-label">Type</p>
              <p className="value">{ToFirstCapital(data?.type)}</p>
            </div>

            <div className="cab-info-item">
              <p className="cab-label">Rate Per Unit</p>
              <p className="value">
                {data?.rate_per_unit} {data?.currency}
              </p>
            </div>

            <div className="cab-info-item">
              <p className="cab-label">Unit</p>
              <p className="value">{data?.rate_per_unit_measure_in}</p>
            </div>

            <div className="cab-info-item">
              <p className="cab-label">Seats</p>
              <p className="value">{data?.no_of_seats}</p>
            </div>

            <div className="cab-info-item">
              <p className="cab-label">Country</p>
              <div className="flag-wrapper">
                <img
                  src={`${FLAG_URL}${data?.country?.country_flag}`}
                  alt="Flag"
                  className="flag-image"
                />
                <p className="value">{data?.country?.country_name}</p>
              </div>
            </div>
          </div>

          <div className="meta-info-grid">
            <div className="cab-info-item">
              <p className="cab-label">Status</p>
              <p className="value">{ToFirstCapital(data?.status)}</p>
            </div>
            <div>
              <p className="cab-label">Created At</p>
              <p className="value">
                {moment(data?.created_at).format("DD MMM YYYY, h:mm A")}
              </p>
            </div>

            <div>
              <p className="cab-label">Updated By</p>
              <p className="value">{data?.updated_by || "N/A"}</p>
            </div>
            <div>
              <p className="cab-label">Deleted By</p>
              <p className="value">{data?.deleted_by || "N/A"}</p>
            </div>
            <div>
              <p className="cab-label">Deleted At</p>
              <p className="value">
                {data?.deleted_at
                  ? moment(data?.deleted_at).format("DD MMM YYYY")
                  : "N/A"}
              </p>
            </div>
            <div>
              <p className="cab-label">Is Deleted</p>
              <p className="value">{data?.is_deleted ? "Yes" : "No"}</p>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ViewCabSettings;
